import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './thankYouScreen.module.css';

import { ReactComponent as CheckCircle } from 'asset/CustomIcons/filled-check-circle.svg';

import ScreenFrame from '../../components/ScreenFrame';
import Stepper from '../../components/Stepper';
import ThemedButton from '../../components/ThemedButton';
import { THANK_YOU_TITLE } from '../../helper/constants';

const ThankYouScreen = ({ logo, steps, returnLabel }) => (
    <ScreenFrame
        logo={logo}
        stepper={steps && <Stepper steps={steps} activeStep={steps.length} />}
        cardClassName={styles.card}
        bodyClassName={styles.body}
    >
        <CheckCircle className={styles.check} />
        <Typography className={styles.title}>{THANK_YOU_TITLE}</Typography>
        {returnLabel && (
            <Box className={styles.action}>
                <ThemedButton>{returnLabel}</ThemedButton>
            </Box>
        )}
    </ScreenFrame>
);

ThankYouScreen.propTypes = {
    logo: PropTypes.string,
    steps: PropTypes.arrayOf(PropTypes.string),
    returnLabel: PropTypes.string,
};

export default ThankYouScreen;
